export const liveToastData = [
  {
    text: "Use the .hide class through ",
    code: ".hide and .show, [top-0/bottom-0/start-0/end-0] ",
  },
  {
    text: "class through visible toast and given directions.",
  },
];

export const colorSchema = [
  {
    text: "Use the ",
    code: ".hide",
  },
  {
    text: ".show ",
    code: "class through visible toast.",
  },
];

export const stackingToastData = [
  {
    text: "You can stack toasts by wrapping them in a toast container, which will vertically add some spacing. ",
    code: "[toast-*]",
  },
  {
    text: "through change icons colors.",
  },
];

export const stackingToastDataList = [
  {
    bell: true,
    iconColor: "warning",
    title: "Roxo Template",
    time: "2 sec ago",
    bodyText: "Hello, I'm a UX-designer.",
  },
  {
    bell: true,
    iconColor: "danger",
    title: "Zeta Template",
    time: "6 min ago",
    bodyText: "Hello, I'm a Software developer.",
  },
  {
    bell: true,
    iconColor: "success",
    title: "Voxo Template",
    time: "3 sec ago",
    bodyText: "Hello, I'm a professional web-designer.",
  },
];

export const translucentToastData = [
  {
    text: " Use the ",
    code: ".hide ",
  },
  {
    text: "class through hide toast and ",
    code: ".show ",
  },
  {
    text: "class through visible toast and given directions.",
    code: "[toast-*]",
  },
  {
    text: "through change icons colors.",
  },
];

export const translucentToastDataList = [
  {
    iconColor: "dark",
    title: "Koho Template",
    time: "1 sec ago",
    bodyText: " Hello, I'm a full-stack developer.",
  },
  {
    iconColor: "secondary",
    title: "Fastkart Template",
    time: "just now",
    bodyText: " Hello, I'm a UX-designer.",
  },
  {
    iconColor: "success",
    title: "Oslo Template",
    time: "44 min ago",
    bodyText: "Hello, I'm a professional web-designer.",
  },
];

export const defaultToastData = [
  {
    text: " Use the ",
    code: ".hide ",
  },
  {
    text: "class through hide toast and ",
    code: ".show ",
  },
  {
    text: "class through visible toast.",
  },
];

export const uniqueToastData = [
  {
    text: " Use the ",
    code: ".hide ",
  },
  {
    text: "class through hide toast and ",
    code: ".show ",
  },
  {
    text: "class through visible toast.",
  },
];

export const placementData = [
  {
    text: " Use the ",
    code: ".hide ",
  },
  {
    text: "class through hide toast and ",
    code: ".show ",
  },
  {
    text: "class through visible toast.",
    code: ".form-select",
  },
  {
    text: " through select any positions.",
  },
];

export const placementListData = [
  {
    text: "Top left",
    className: "top-0 start-0",
  },
  {
    text: "Top center",
    className: "top-0 start-50 translate-middle-x",
  },
  {
    text: "Top right",
    className: "top-0 end-0",
  },
  {
    text: "Middle left",
    className: "top-50 start-0 translate-middle-y",
  },
  {
    text: "Middle center",
    className: "top-50 start-50 translate-middle",
  },
  {
    text: "Middle right",
    className: "top-50 end-0 translate-middle-y",
  },
  {
    text: "Bottom left",
    className: "bottom-0 start-0",
  },
  {
    text: "Bottom center",
    className: "bottom-0 start-50 translate-middle-x",
  },
  {
    text: "Bottom right",
    className: "bottom-0 end-0",
  },
];
